<template>
  <div class="infoList">
    <!-- 列表 -->
    <div class="listBox" v-if="!loadMore">
      <div
        v-for="(item, index) in datas"
        :key="index"
        class="item s_img b_img"
        @click="jumpPage(item.share_url || item.url)"
      >
        <!-- 无图 -->
        <template v-if="item.card_type == 0">
          <div>
            <p class="title van-multi-ellipsis--l2">{{ item.title }}</p>
            <div class="option clear mt12">
              <span
                v-for="(elem, index) in item.tags"
                :key="index"
                class="else fl"
                :style="{
                  background: elem.border_color,
                  color: elem.font_color,
                }"
              >
                {{ elem.name }}
              </span>
              <span class="time fr">{{ item.pub_time }}</span>
            </div>
          </div>
        </template>
        <!-- 小图 -->
        <template v-if="item.card_type == 1">
          <div>
            <div class="info flex justify-bet">
              <p class="title flex_1 van-multi-ellipsis--l3 pr12">
                {{ item.title }}
              </p>
              <van-image
                lazy-load
                fit="cover"
                width="120"
                height="80"
                :src="item.image"
              />
            </div>
            <div class="option clear" style="margin-top: 8px">
              <span
                v-for="(elem, index) in item.tags"
                :key="index"
                class="else fl"
                :style="{
                  background: elem.border_color,
                  color: elem.font_color,
                }"
              >
                {{ elem.name }}
              </span>
              <span class="time fr">{{ item.pub_time }}</span>
            </div>
          </div>
        </template>
        <!-- 大图 -->
        <template v-if="item.card_type == 2">
          <div>
            <p class="title van-multi-ellipsis--l2">{{ item.title }}</p>
            <div class="imgBox mt12">
              <van-image
                lazy-load
                fit="cover"
                width="100%"
                height="188"
                :src="item.image"
              />
              <i class="playBtn" v-if="item.type == 4"></i>
              <span class="yugao" v-if="item.status == 1">预告</span>
              <span class="living" v-if="item.status == 2">直播中</span>
              <span class="huigu" v-if="item.status == 3">回顾</span>
            </div>
            <div class="option clear mt8">
              <span
                v-for="(elem, index) in item.tags"
                :key="index"
                class="else fl"
                :style="{
                  background: elem.border_color,
                  color: elem.font_color,
                }"
              >
                {{ elem.name }}
              </span>
              <span class="time fr">{{ item.pub_time }}</span>
            </div>
          </div>
        </template>
        <!-- 三图 -->
        <template v-if="item.card_type == 3">
          <div>
            <p class="title van-multi-ellipsis--l2">{{ item.title }}</p>
            <div class="imgBoxs clear">
              <van-image
                lazy-load
                fit="cover"
                class="img"
                v-for="(elem, index) in item.images"
                :key="index"
                :src="elem"
              />
              <span v-if="dataItem.images.length > 3" class="count">{{
                item.img_num
              }}</span>
            </div>
            <div class="option clear mt8">
              <span
                v-for="(elem, index) in item.tags"
                :key="index"
                class="else fl"
                :style="{
                  background: elem.border_color,
                  color: elem.font_color,
                }"
              >
                {{ elem.name }}
              </span>
              <span class="time fr">{{ item.pub_time }}</span>
            </div>
          </div>
        </template>
        <!-- 视频 -->
        <!-- <template v-if="item.type == 4">
                    <div>
                        <p class="title van-multi-ellipsis--l2">{{item.title}}</p>
                        <div class="imgBox mt12">
                            <van-image
                                lazy-load
                                fit="cover"
                                width="100%"
                                height="100%"
                                :src="item.image"
                            />
                            <i class="playBtn"></i>
                        </div>
                        <div class="option clear mt8">
                            <span 
                                v-for="(elem, index) in  item.tags" 
                                :key="index" class="else fl" 
                                :style="{background: elem.border_color, color: elem.font_color}"
                            >
                                {{elem.name}}
                            </span>
                            <span class="time fr">{{item.pub_time}}</span>
                        </div>
                    </div>
                </template> -->
        <!-- 直播-->
        <!-- <template v-if="item.type == 6">
                    <div>
                        <p class="title van-multi-ellipsis--l2">{{item.title}}</p>
                        <div class="imgBox mt12">
                            <van-image
                                lazy-load
                                fit="cover"
                                width="100%"
                                height="100%"
                                :src="item.image"
                            />
                            <i class="liveBtn"></i>
                            <span class="living">直播中</span>
                        </div>
                        <div class="option clear mt8">
                            <span 
                                v-for="(elem, index) in  item.tags" 
                                :key="index" class="else fl" 
                                :style="{background: elem.border_color, color: elem.font_color}"
                            >
                                {{elem.name}}
                            </span>
                            <span class="time fr">{{item.pub_time}}</span>
                        </div>
                    </div>
                </template> -->
      </div>
    </div>
    <!-- 加载更多的列表 -->
    <div
      class="listBox"
      v-if="!(dataItem.card_type == 100 || dataItem.card_type == 200)"
    >
      <div
        class="item s_img b_img"
        @click="jumpPage(dataItem.share_url || dataItem.url)"
      >
        <!-- 无图 -->
        <template v-if="dataItem.card_type == 0">
          <div>
            <p class="title van-multi-ellipsis--l2">{{ dataItem.title }}</p>
            <div class="option clear mt12">
              <span
                v-for="(elem, index) in dataItem.tags"
                :key="index"
                class="else fl"
                :style="{
                  background: elem.border_color,
                  color: elem.font_color,
                }"
              >
                {{ elem.name }}
              </span>
              <span class="time fr">{{ dataItem.pub_time }}</span>
            </div>
          </div>
        </template>
        <!-- 小图 -->
        <template v-if="dataItem.card_type == 1">
          <div>
            <div class="info flex justify-bet">
              <p class="flex_1 title van-multi-ellipsis--l3 pr12">
                {{ dataItem.title }}
              </p>
              <van-image
                lazy-load
                fit="cover"
                width="120"
                height="80"
                :src="dataItem.image"
              />
            </div>
            <div class="option clear" style="margin-top: 8px">
              <span
                v-for="(elem, index) in dataItem.tags"
                :key="index"
                class="else fl"
                :style="{
                  background: elem.border_color,
                  color: elem.font_color,
                }"
              >
                {{ elem.name }}
              </span>
              <span class="time fr">{{ dataItem.pub_time }}</span>
            </div>
          </div>
        </template>
        <!-- 大图 -->
        <template v-if="dataItem.card_type == 2">
          <div>
            <p class="title van-multi-ellipsis--l2">{{ dataItem.title }}</p>
            <div class="imgBox mt12">
              <van-image
                lazy-load
                fit="cover"
                width="100%"
                height="188"
                :src="dataItem.image"
              />
              <i class="playBtn" v-if="dataItem.type == 4"></i>
              <span class="yugao" v-if="dataItem.status == 1">预告</span>
              <span class="living" v-if="dataItem.status == 2">直播中</span>
              <span class="huigu" v-if="dataItem.status == 3">回顾</span>
            </div>
            <div class="option clear mt8">
              <span
                v-for="(elem, index) in dataItem.tags"
                :key="index"
                class="else fl"
                :style="{
                  background: elem.border_color,
                  color: elem.font_color,
                }"
              >
                {{ elem.name }}
              </span>
              <span class="time fr">{{ dataItem.pub_time }}</span>
            </div>
          </div>
        </template>
        <!-- 三图 -->
        <template v-if="dataItem.card_type == 3">
          <div>
            <p class="title van-multi-ellipsis--l2">{{ dataItem.title }}</p>
            <div class="imgBoxs clear">
              <van-image
                lazy-load
                fit="cover"
                class="img"
                v-for="(elem, index) in dataItem.images"
                :key="index"
                :src="elem"
              />
              <span v-if="dataItem.images.length > 3" class="count">{{
                dataItem.img_num
              }}</span>
            </div>
            <div class="option clear mt8">
              <span
                v-for="(elem, index) in dataItem.tags"
                :key="index"
                class="else fl"
                :style="{
                  background: elem.border_color,
                  color: elem.font_color,
                }"
              >
                {{ elem.name }}
              </span>
              <span class="time fr">{{ dataItem.pub_time }}</span>
            </div>
          </div>
        </template>
        <!-- 视频 -->
        <!-- <template v-if="dataItem.type == 4">
                    <div>
                        <p class="title van-multi-ellipsis--l2">{{dataItem.title}}</p>
                        <div class="imgBox mt12">
                            <van-image
                                lazy-load
                                fit="cover"
                                width="100%"
                                height="100%"
                                :src="dataItem.image"
                            />
                            <i class="playBtn"></i>
                        </div>
                        <div class="option clear mt8">
                            <span 
                                v-for="(elem, index) in  dataItem.tags" 
                                :key="index" class="else fl" 
                                :style="{background: elem.border_color, color: elem.font_color}"
                            >
                                {{elem.name}}
                            </span>
                            <span class="time fr">{{dataItem.pub_time}}</span>
                        </div>
                    </div>
                </template> -->
        <!-- 直播-->
        <!-- <template v-if="dataItem.type == 6">
                    <div>
                        <p class="title van-multi-ellipsis--l2">{{dataItem.title}}</p>
                        <div class="imgBox mt12">
                            <van-image
                                lazy-load
                                fit="cover"
                                width="100%"
                                height="100%"
                                :src="dataItem.image"
                            />
                            <i class="liveBtn"></i>
                            <span class="living">直播中</span>
                        </div>
                        <div class="option clear mt8">
                            <span 
                                v-for="(elem, index) in  dataItem.tags" 
                                :key="index" class="else fl" 
                                :style="{background: elem.border_color, color: elem.font_color}"
                            >
                                {{elem.name}}
                            </span>
                            <span class="time fr">{{dataItem.pub_time}}</span>
                        </div>
                    </div>
                </template> -->
      </div>
    </div>
    <!-- 拍客列表 -->
    <div
      class="listBox"
      style="padding: 0"
      v-if="dataItem.card_type == 100 || dataItem.card_type == 200"
    >
      <div class="patting-title">
        <span>{{ dataItem.title }}</span
        ><a @click="jumpMore(dataItem.card_type)" class="patting-more fr"
          >更多<i></i
        ></a>
      </div>
      <div>
        <ul class="patting-remmend">
          <li v-for="item in dataItem.data" :key="item.id">
            <a @click="jump_patting(dataItem.card_type, item.id, item.share)">
              <div class="patting-rem-top">
                <img :src="item.cover" class="patting-img" />
                <div class="clear patting-rem-po">
                  <div class="fl patting-head">
                    <van-image
                      lazy-load
                      fit="cover"
                      width="24"
                      height="24"
                      :src="item.user_image"
                    />
                    <!-- <i class="vip"></i> -->
                  </div>
                  <div class="fl patting-name">{{ item.author }}</div>
                  <div v-if="dataItem.card_type == 100" class="fr playback-fr">
                    <i></i>{{ item.views }}
                  </div>
                </div>
              </div>
              <div class="playback-bottom van-multi-ellipsis--l2">
                <p style="overflow: hidden">{{ item.content }}</p>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { navigate, checkWx } from "@/pages/index/custom.js";
import Contents from "@/request/base.default.js";

export default {
  props: {
    datas: {
      type: Array,
      default: () => [],
    },
    dataItem: {
      type: Object,
      default: () => {},
    },
    loadMore: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      test: require("../assets/img/live_avatar.jpg"),
    };
  },
  methods: {
    jumpPage(url) {
      navigate("", url);
    },
    // 跳转拍客
    jump_patting(type, id, url = "") {
      if (type == 100) {
        navigate("", url);
      } else if (type == 200) {
        navigate("", Contents.baseURL + "/web/space/content/" + id);
      }
    },
    jumpMore(type) {
      if (type == 100) {
        if (checkWx()) {
          wx.miniProgram.switchTab({ url: "../video/video" });
        } else {
          this.$router.push("/patting/comment");
        }
      } else if (type == 200) {
        if (checkWx()) {
          wx.miniProgram.switchTab({ url: "../cicle/cile" });
        } else {
          this.$router.push("/main/find");
        }
      }
    },
  },
  created() {
    // console.log(this.dataItem.id)
  },
};
</script>

<style lang="less" scoped>
.van-cell:not(:last-child)::after {
  border-bottom: none;
}
.listBox {
  box-sizing: border-box;
  padding: 0 20px;
  .item {
    border-bottom: 1px solid #eee;
  }
  .pr12 {
    padding-right: 0.75rem;
  }
  .mt8 {
    margin-top: 0.5rem !important;
  }
  .mt12 {
    margin-top: 0.75rem !important;
  }
  .s_img {
    box-sizing: border-box;
    & > div {
      box-sizing: border-box;
      padding: 20px 0;
    }
    .info {
      box-sizing: border-box;
    }
    .title {
      font-size: 18px;
      font-weight: 500;
      color: rgba(34, 34, 34, 1);
      line-height: 26px;
    }
  }
  .b_img {
    box-sizing: border-box;
    & > div {
      box-sizing: border-box;
      padding: 20px 0;
    }
    .living {
      position: absolute;
      top: 0.75rem;
      right: 0.75rem;
      height: 20px;
      line-height: 20px;
      padding-right: 8px;
      padding-left: 22px;
      background: url(../assets/img/ic_live_s.png) no-repeat 8px center;
      background-size: 12px 12px;
      background-color: #ff4c67;
      font-size: 12px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      border-radius: 2px;
    }
    .huigu {
      position: absolute;
      top: 0.75rem;
      right: 0.75rem;
      height: 20px;
      line-height: 20px;
      padding: 0 8px;
      background-color: #00c5aa;
      font-size: 12px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      border-radius: 2px;
      text-align: center;
    }
    .yugao {
      position: absolute;
      top: 0.75rem;
      right: 0.75rem;
      height: 20px;
      line-height: 20px;
      padding: 0 8px;
      background-color: #2e8cff;
      font-size: 12px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      border-radius: 2px;
      text-align: center;
    }
    .playBtn {
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -1.75rem;
      margin-top: -1.75rem;
      width: 3.5rem;
      height: 3.5rem;
      background: url(../assets/img/ic_playBtn.png) no-repeat;
      background-size: 100% 100%;
    }
    .liveBtn {
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -1.75rem;
      margin-top: -1.75rem;
      width: 3.5rem;
      height: 3.5rem;
      background: url(../assets/img/ic_live_b.png) no-repeat;
      background-size: 100% 100%;
    }
    .title {
      font-size: 18px;
      font-weight: 500;
      color: rgba(34, 34, 34, 1);
      line-height: 26px;
    }
    .imgBox {
      width: 100%;
      height: 11.75rem;
      border-radius: 6px;
      overflow: hidden;
      position: relative;
    }
    .imgBoxs {
      width: 100%;
      border-radius: 6px;
      overflow: hidden;
      position: relative;
      .img {
        float: left;
        width: 32.8%;
        height: 4.625rem;
      }
      & > .img:nth-child(2) {
        margin: 0 0.8%;
      }
      .count {
        position: absolute;
        right: 0.5rem;
        bottom: 0.5rem;
        width: auto;
        height: 1.25rem;
        line-height: 1.25rem;
        padding: 0 0.5rem;
        font-size: 12px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        border-radius: 100px;
        background-color: rgba(0, 0, 0, 0.7);
      }
    }
  }
  .option {
    margin: 0;
    .top {
      width: auto;
      padding: 0 4px;
      height: 16px;
      line-height: 16px;
      background-color: #ff4c67;
      text-align: center;
      font-size: 9px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      border-radius: 2px;
    }
    .only {
      width: auto;
      padding: 0 4px;
      height: 16px;
      line-height: 16px;
      background-color: #2e8cff;
      margin-right: 4px;
      text-align: center;
      font-size: 10px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      border-radius: 2px;
    }
    .time {
      font-size: 12px;
      font-weight: 400;
      color: rgba(167, 167, 167, 1);
      line-height: 21px;
    }
    .else {
      width: auto;
      padding: 0 4px;
      height: 16px;
      line-height: 16px;
      margin-right: 4px;
      text-align: center;
      font-size: 10px;
      font-weight: 400;
      border-radius: 2px;
    }
  }
}
</style>
